// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__L_QUs","boxTitle":"Qualiphy_boxTitle__hcAWs","box":"Qualiphy_box__3DzHT","toggleWrap":"Qualiphy_toggleWrap__FGBUr"};